// @flow
import React from 'react'
import styled, { type StyledComponent } from 'styled-components'
import OptionalResponsibleImage from './OptionalResponsibleImage'
import type { Media, Crop } from '../../types'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 300px;
  background-color: #ffffff;
  border: 1px solid #bdbdbd;
  border-color: #e9e9e9;
`
const Canvas: StyledComponent<Object, any, any> = styled.div`
  text-align: center;
`
const Info: StyledComponent<Object, any, any> = styled.div`
  min-height: 60px;
  position: relative;
  padding: 5px 60px 7px 15px;
  font-size: 14px;
  line-height: 14px;
  padding: 11px 13px 13px;
`
const Link: StyledComponent<Object, any, any> = styled.div`
  margin-top: 3px;
  color: #4f4f4f;
`
const Text: StyledComponent<Object, any, any> = styled.div`
  min-height: 42px;
  color: #272727;
`
const Toolbar: StyledComponent<Object, any, any> = styled.div`
  margin-top: 9px;
  &:after {
    content: '';
    display: table;
    clear: both;
  }
`
const ToolbarSidebar: StyledComponent<Object, any, any> = styled.div`
  float: right;
`
const ToolbarContainer: StyledComponent<Object, any, any> = styled.div`
  overflow: hidden;
`
const More: StyledComponent<Object, any, any> = styled.div`
  color: #4288f5;
  text-transform: uppercase;
`

type Props = {|
  title: string,
  url: string,
  image: ?Media,
  imageCrop: ?Crop
|}

export default function GoogleSimple(props: Props) {
  const { url, title, image, imageCrop } = props

  return (
    <Wrapper>
      <Canvas>
        <OptionalResponsibleImage image={image} imageCrop={imageCrop} width={298} ratio={1.91} />
      </Canvas>
      <Info>
        <Text>{title}</Text>
        <Toolbar>
          <ToolbarSidebar>
            <More>Перейти</More>
          </ToolbarSidebar>
          <ToolbarContainer>
            <Link>{url}</Link>
          </ToolbarContainer>
        </Toolbar>
      </Info>
    </Wrapper>
  )
}
